import { render, staticRenderFns } from "./TransferenciaPremios.vue?vue&type=template&id=6b55162a&"
import script from "./TransferenciaPremios.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPremios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports